<template>
  <div class="transactions-view">
    <h1 class="text-h4 mb-4">{{ t('tx.title') }}</h1>
    
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="filtroStatus"
              :items="opcoesStatus"
              label="Filtrar por status"
              density="comfortable"
              variant="outlined"
            ></v-select>
          </v-col>
          
          <v-col cols="12" sm="4">
            <v-select
              v-model="filtroTipo"
              :items="opcoesTipos"
              label="Filtrar por tipo"
              density="comfortable"
              variant="outlined"
              clearable
            ></v-select>
          </v-col>
          
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filtroEndereco"
              label="Endereço (origem ou destino)"
              density="comfortable"
              variant="outlined"
              clearable
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <div class="mt-4">
      <TransacoesList :transacoes="transacoesFiltradas" :loading="carregando" />
    </div>
    
    <v-pagination
      v-model="paginaAtual"
      :length="totalPaginas"
      :total-visible="7"
      class="mt-4"
    ></v-pagination>
  </div>
</template>

<script>
import { useBlockchainStore } from '@/stores/blockchain'
import TransacoesList from '@/components/transactions/TransacoesList.vue'

export default {
  name: 'TransactionsView',
  components: {
    TransacoesList
  },
  data() {
    return {
      carregando: true,
      transacoes: [],
      paginaAtual: 1,
      itensPorPagina: 10,
      totalTransacoes: 0,
      filtroStatus: 'todos',
      filtroTipo: null,
      filtroEndereco: '',
      opcoesStatus: [
        { title: 'Todas', value: 'todos' },
        { title: 'Confirmadas', value: 'confirmed' },
        { title: 'Pendentes', value: 'pending' },
        { title: 'Falhas', value: 'failed' }
      ],
      opcoesTipos: [
        { title: 'Transferência', value: 'transfer' },
        { title: 'Contrato', value: 'contract' },
        { title: 'Token', value: 'token' },
        { title: 'Validador', value: 'validator' }
      ]
    }
  },
  computed: {
    blockchainStore() {
      return useBlockchainStore()
    },
    
    totalPaginas() {
      return Math.ceil(this.totalTransacoes / this.itensPorPagina)
    },
    
    transacoesFiltradas() {
      let resultado = [...this.transacoes]
      
      // Filtro por status: 'confirmed', 'failed', 'pending' ou 'todos'
      if (this.filtroStatus && this.filtroStatus !== 'todos') {
        resultado = resultado.filter(tx => tx.status === this.filtroStatus)
      }
      
      // Filtro por tipo de transação
      if (this.filtroTipo) {
        resultado = resultado.filter(tx => tx.type === this.filtroTipo)
      }
      
      // Filtro por endereço (origem ou destino)
      if (this.filtroEndereco && this.filtroEndereco.trim() !== '') {
        const endereco = this.filtroEndereco.trim().toLowerCase()
        resultado = resultado.filter(tx => 
          (tx.from && tx.from.toLowerCase().includes(endereco)) || 
          (tx.to && tx.to.toLowerCase().includes(endereco))
        )
      }
      
      return resultado
    }
  },
  methods: {
    async carregarTransacoes() {
      this.carregando = true
      
      try {
        // Em produção, isso seria uma chamada para a API
        await this.blockchainStore.fetchLatestTransactions(20)
        this.transacoes = this.blockchainStore.latestTransactions
        this.totalTransacoes = this.blockchainStore.stats.totalTransactions || 10000 // Em produção, viria da API
        
        console.log('Transações carregadas:', this.transacoes.length)
      } catch (error) {
        console.error('Erro ao carregar transações:', error)
      } finally {
        this.carregando = false
      }
    }
  },
  async mounted() {
    await this.carregarTransacoes()
  },
  watch: {
    paginaAtual() {
      this.carregarTransacoes()
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.transactions-view {
  padding-bottom: 32px;
}
</style>
